import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "medium",
    loading: _ctx.state.is_loading,
    title: _ctx.modalTitle,
    "confirm-button-class": _ctx.confirmButtonClass,
    "confirm-button-text": _ctx.confirmButtonText,
    onConfirm: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        placeholder: "Комментарий",
        value: _ctx.state.comment,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.comment) = $event)),
        disabled: _ctx.state.is_loading
      }, null, 8, ["value", "disabled"])
    ]),
    _: 1
  }, 8, ["loading", "title", "confirm-button-class", "confirm-button-text", "onConfirm", "onCancel"]))
}